import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/common-services/user.services';
import { AuthenticationService } from 'src/app/core/data-services/authentication.service';
import { AppConfigService } from 'src/app/core/config/app-config.service';

@Component({
  selector: 'app-top-nav-bar',
  templateUrl: './top-nav-bar.component.html',
  styleUrls: ['./top-nav-bar.component.css']
})
export class TopNavBarComponent implements OnInit {
  userName = '';
  userInitials = '';

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    public appConfigService: AppConfigService
  ){ }
  ngOnInit(): void {
    this.userName = this.userService.getUserName() || 'User';
    this.userInitials = this.userName.charAt(0).toUpperCase();
  }
  logOut() {
    return this.authenticationService.logout( ).subscribe(
      () => {
        this.userService.logout();
      })
  }
}
